import { z } from "zod";
import { dmaAmountDtoSchema } from "./dma-amount.schema";
export const dmaMicelleCompoundDtoSchema = z.object({
    compoundId: z.number(),
    amount: dmaAmountDtoSchema,
});
